export default __webpack_public_path__ + "static/media/377.e4691c91.jpg";